<template>
    <div>
        <template v-if="!autoSend">
            <hr>
            <div class="row">
                <div class="col-md-6 col-md-push-5">
                    <img src="/img/orbital/catalogue/checkout-catalogue.jpg" style="max-width: 300px; width: 100%" alt="Free Catalogues">
                </div>
                <div class="col-md-5 col-md-pull-6">
                    <p class="h4 catalogue-position">Get your <u class="u--red">Free</u> Catalogues</p>
                    <p>Add up to 5 free catalogues to your order.</p>
                    <p><em class="em--muted">Why not get your co-worker or team a catalogue each?</em></p>
                    <div v-if="catalogueCount >= 5">
                        <p class="text-info">You have reached the catalogue limit for an order</p>
                    </div>
                    <div v-else>
                        <div class="row">
                            <div class="col-md-10 col-lg-8">
                                <div class="input-group">
                                    <input type="number" class="form-control" min="0" max="5" v-model="qty">
                                    <span class="input-group-addon btn btn-sm btn-blue" @click="save">
                                        Add Catalogue<template v-if="qty > 1">s</template>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="text-danger" v-if="error">{{ error }}</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="catalogueCount">
            <hr>
            <p>We've added <u><strong>{{ catalogueCount }}</strong> FREE Catalogue<template v-if="catalogueCount > 1">s</template></u> to your order.</p> 
            <button class="btn btn-sm btn-red" @click="removeCatalogues">Remove Catalogue<template v-if="catalogueCount > 1">s</template></button>
        </template>
        <div class="row">
            <div class="col-xs-12">
                <div class="alert alert-info" v-if="message">
                    <p>{{ message }}</p>
                </div>
            </div>
        </div>
    <hr>
    </div>
</template>

<script>
    import Order from '../../Services/Order.js';
    import Catalogue from '../../Services/Catalogue.js';

    export default {
        props: {
            billingEmail: {
                type: String,
                default: null,
            },
        },
        data() {
            return {
                autoSend: false,
                orders: Order,
                error: null,
                message: null,
                qty: 1
            }
        },
        mounted() {
            // Catalogue.getInfo(this.billingEmail).then(response => {
            //     this.autoSend = response.auto_send_new;
            //     if (this.autoSend && !this.catalogueCount) {
            //         this.orders.addLine('Catalogue', 'Catalogue', 0, this.qty, 0).then(response => {
            //             //
            //         });
            //     }
            // });
        },
        methods: {
            removeCatalogues() {
                const lines = _.filter(this.orders.order.lines, line => {
                    return line.description == 'Catalogue';
                });
                _.each(lines, line => {
                    this.orders.removeLine(line.id);
                });
                this.autoSend = false;
                this.$emit('catalogues-removed');
            },
            save() {
                this.error = null;
                if (this.catalogueCount >= 5) {
                    this.error = 'You already have 5 catalogues on this order';
                    return;
                } else if ((parseInt(this.catalogueCount) + parseInt(this.qty)) > 5) {
                    this.error = 'You can only have a maximum of 5 catalogues per order';
                    return;
                } else if (this.qty < 0) {
                    this.error = 'You must choose a quantity';
                    return;
                }
                let qty = this.qty;

                this.orders.addLine('Catalogue', 'Catalogue', 0, this.qty, 0).then(response => {
                    this.showMessage(qty);
                });
                this.qty = 0;
            },
            showMessage(qty) {
                let plural = 'catalogues';
                if (qty == 1) {
                    plural = 'catalogue';
                }
                this.message = 'Added ' + qty +  ' ' + plural + ' to your order';

                setTimeout(() => {
                    this.message = null;
                }, 2000);
            }
        },
        computed: {
            catalogueCount() {
                let total = 0,
                    lines = _.filter(this.orders.order.lines, line => {
                        return line.description == 'Catalogue';
                    });

                _.each(lines, line => {
                    total += line.quantity;
                });

                return total;
            }
        }
    }
</script>

<style scoped>
    .catalogue-position {
        margin-top: 45px;
    }

    @media screen and (max-width: 1199px) {
        .catalogue-position {
            margin-top: 15px;
        }
    }

    .u--red {
        color: #d40f2e;
    }

    .em--muted {
        opacity: 0.7;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Checkout/CatalogueOrder.vue